const SvgDownload2 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 40 40">
    <path fill="#fff" d="M7 33v-1.534h26V33zm13-6.134-7.605-7.72 1.083-1.1 5.767 5.854V6h1.51v17.9l5.717-5.802 1.083 1.1z" />
  </svg>;
export default SvgDownload2;